import React, { useState } from 'react';
import { joinClasses } from '../../../../Utils/className.util';
// @ts-ignore
import styles from './PriorityPicker.module.scss';
import { Theme } from '../../../../Enums/Theme.enum';
import { RequestPriority } from '../../../MonitoringCenter/Enums/RequestPriority.enum';
import ContextMenu, {
	ContextMenuParams,
} from '../../../../Components/ContextMenu/ContextMenu';
import LinkButton from '../../../../Components/Button/LinkButton';
import Text from '../../../../Components/Base/Text/Text';
import useTranslation from '../../../../Hooks/useTranslation';

export interface PriorityPickerValue {
	id: string;
	key: RequestPriority;
	title: string;
	color: Theme;
}

interface Props {
	options: PriorityPickerValue[];
	onPick: (item: PriorityPickerValue) => void;
	value?: PriorityPickerValue;
}

const PriorityPicker: React.FC<Props> = ({ value, options, onPick }) => {
	const { t } = useTranslation();
	const [contextMenuProps, setContextMenuProps] = useState<ContextMenuParams>({
		isOpen: false,
	});
	const [pickedValue, setPickedValue] = useState<
		PriorityPickerValue | undefined
	>(value);

	const openContext = (event: any) => {
		setContextMenuProps({
			isOpen: true,
			clientX: event.clientX,
			clientY: event.clientY,
		});
	};

	const setPriority = (item: PriorityPickerValue) => {
		setPickedValue(item);
		onPick(item);
		setContextMenuProps({
			isOpen: false,
		});
	};

	return (
		<>
			<div
				onClick={openContext}
				className={joinClasses([styles.wrapper, styles[pickedValue?.color]])}>
				<div className={styles.title}>{t(pickedValue?.title)}</div>
			</div>
			<ContextMenu
				params={contextMenuProps}
				openInModalRoot={true}
				customRootName='context-menu-root'
				onContextClose={() => {
					setContextMenuProps({ isOpen: false });
				}}>
				{options.map((item, index) => (
					<div
						key={index}
						className={joinClasses([styles.pickerButton, styles[item.color]])}
						onClick={() => setPriority(item)}>
						<Text className={styles.text} tx={item.title} />
					</div>
				))}
			</ContextMenu>
		</>
	);
};

export default PriorityPicker;
